import { render, staticRenderFns } from "./Toplist.vue?vue&type=template&id=04b8dd31&scoped=true&"
import script from "./Toplist.vue?vue&type=script&lang=js&"
export * from "./Toplist.vue?vue&type=script&lang=js&"
import style0 from "./Toplist.vue?vue&type=style&index=0&id=04b8dd31&prod&lang=css&"
import style1 from "./Toplist.vue?vue&type=style&index=1&id=04b8dd31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8dd31",
  null
  
)

export default component.exports